import React from 'react';
import ContactUsForm from '../../common/components/Forms/ContactUsForm';

const ContactUs = () => {
  return <ContactUsForm light={true} />;
};

export default ContactUs;
